import { create } from 'zustand'

interface HeaderState {
  isMenuOpen: boolean
  setIsMenuOpen: (v: boolean) => void
  navSlideIdx: number
  setNavSlideIdx: (v: number) => void
  isSearchTakeoverVisible: boolean
  setIsSearchTakeoverVisible: (v: boolean) => void
  reset: () => void
}

export const useHeaderStore = create<HeaderState>()((set) => ({
  isMenuOpen: false,
  setIsMenuOpen: (v) => set({ isMenuOpen: v }),
  navSlideIdx: -1,
  setNavSlideIdx: (v) => set({ navSlideIdx: v }),
  isSearchTakeoverVisible: false,
  setIsSearchTakeoverVisible: (v) => set({ isSearchTakeoverVisible: v }),
  reset: () => set({ isMenuOpen: false, navSlideIdx: -1, isSearchTakeoverVisible: false }),
}))
